<template>
  <div class="fullscreen aaa" ref="scollElement" style="overflow-x: auto;">
    <div class="rou">
      <router-view @gotoTop="backtop" @getInfo="getHeight" :index="dIndex"></router-view>
    </div>
    <div style="width: 3px;height: 100%;padding: 10% 0;position:absolute;top: 0;right: 5px;display: flex;flex-direction:column;justify-content: space-between;" v-show="state==1&&w_width<888&&dIndex!=0">
      <div style="height: 32%;width: 100%" :style="{background:dIndex==1?'#6494F5':'#FFFFFF'}">
      </div>
      <div style="height: 32%;width: 100%" :style="{background:dIndex==2?'#6494F5':'#FFFFFF'}">
      </div>
      <div style="height: 32%;width: 100%" :style="{background:dIndex==3?'#6494F5':'#FFFFFF'}">
      </div>
    </div>
    <div class="t_foot" v-if="w_width<888">
      <div class="fx_cs" style="align-items: flex-start;line-height: 2.3">
        <div class="t_txt1">
          <span class="t_txt2">TMIP产品体系</span><br>
          <span  @click="goto('/mes')">MES 生产管理</span><br>
          <span  @click="goto('/wms')">WMS 智慧仓储</span><br>
          <span  @click="goto('/mtr')">MTR 物料溯源</span><br>
          <span  @click="goto('/emv')">EMV 生产可视化</span>
        </div>
        <div class="t_txt2">
          <span @click="goto('/service')">服务与支持</span><br>
          <span @click="goto('/aboutus')">关于我们</span>
        </div>
      </div>
      <div class="fx_cs" style="margin-top: 50px">
        <div style="text-align: center;">
          <img src="../assets/img/scan.png" style="width: 96px"><br>
          <span class="t_txt3">扫一扫，联系我们</span>
        </div>
        <div style="line-height: 27px">
          <div>
            <div class="t_icon3">
              <i class="iconfont iconlujing2203" style="font-size: 13px"></i>
            </div>
            <span class="t_txt1">400-152-3152</span>
          </div>
          <div>
            <div class="t_icon3">
              <i class="iconfont iconlujing2204" style="font-size: 13px"></i>
            </div>
            <span class="t_txt1">Info@nyy.com.cn</span>
          </div>
          <div>
            <div class="t_icon3">
              <i class="iconfont iconlujing2202" style="font-size: 13px"></i>
            </div>
            <span class="t_txt1">715631337</span>
          </div>
        </div>
      </div>
      <div class="fx_cs" style="margin-top: 46px">
        <div class="t_line"></div>
        <img src="../assets/img/homepage/logotop.png" class="t_logo">
        <div class="t_line"></div>
      </div>
      <div class="t_info">
        南通易阳科技有限公司版权所有<br>
        Copyright &Cop 2005-2020 NYY Technology Co.,Ltd.<br>
        <div class="fx_cc">
          All Rights Reserved
          <img src="../assets/img/homepage/jinghui.png" class="t_img2">
          苏ICP备13038362号
        </div>
      </div>
    </div>
    <div class="footer" v-else style="width: 100%;min-width: 1300px">
      <div class="footer-info" style="padding: 70px 0 50px 0">
        <div class="footer-div">
          <div class="footer-div1 noselect" style="width: 550px;display: flex;justify-content:space-between;">
            <img
              style="width: 140px; height: 39px;margin-top: 50px;opacity: 0.4;cursor: pointer;"
              src="../assets/img/homepage/logobottom.png"
              @click="goto('/')"
            />
            <div style="width: 345px;display: flex;justify-content:end;">

              <div>
                <div style="margin-top: 18px">
                  <span class="footersp1 npointer2" >
                    首页
                  </span>
                </div>
                <div style="margin-top: 18px">
                  <span class="footersp1 npointer2" @click="goto('/service')">
                    服务与支持
                  </span>
                </div>
                <div style="margin-top: 18px">
                  <span class="footersp1 npointer2" @click="goto('/aboutus')">
                    关于我们
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div style="width: 470px;display: flex;justify-content: space-between;margin-top: 10px">
            <div>
              <img src="../assets/img/scan.png" style="width:103px">
              <div style="font-size: 12px;color: #979DBC;text-align: center;">扫一扫，联系我们</div>
            </div>
            <div class="footer-div4">
              <div class="footerdi1">
                <i class="iconfont iconlujing2203"></i>
                <span class="footersp3">400-152-3152</span>
              </div>
              <div class="footerdi1">
                <i class="iconfont iconlujing2204" style="font-size: 12px"></i>
                <span class="footersp3">Info@nyy.com.cn</span>
              </div>
              <div class="footerdi1">
                <i class="iconfont iconlujing2202"></i>
                <span class="footersp3">715631337</span>
                <i class="iconfont iconfont1 iconzu800"></i>
                <span class="footersp3">易阳科技</span>
              </div>
              <div class="footerdi1">
                <i class="iconfont iconlujing2205"></i>
                <span class="footersp3"
                  >江苏省南通市崇川区华汇智谷科学产业园26-1幢5楼</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-beian" style="color: #797788">
        南通易阳科技有限公司版权所有 Copyright &Cop 2005-现在 NYY Technology
        Co.,Ltd. All Rights Reserved
        <img
          style="
            width: 20px;
            height: 20px;
            position: relative;
            top: 6px;
            margin: 0 4px;
          "
          src="../assets/img/homepage/jinghui.png"
        />
        <a class="beianlink" href="https://beian.miit.gov.cn/" target="_blank">苏ICP备13038362号-5</a>
      </div>
    </div>
  </div>
</template>

<script>
import util from "../components/util";
export default util.useCommon({
  data() {
    return {
      w_width:0,
      i_height:0,
      dIndex:0,
      state:0
    };
  },
  watch: {},
  methods: {
    goto(add) {
      this.backtop();
      this.$router.push(add);
    },
    backtop() {
      this.$nextTick(() => {
        if (this.$refs.scollElement) {
          // 滚动元素跳转到顶部
          this.$refs.scollElement.scrollTop = 0;
        }
      });
    },
    getScroll(e){
      // console.log(e.srcElement.scrollTop);
      var tmp1 = window.innerWidth/375*845;
      if(e.srcElement.scrollTop>this.i_height&&e.srcElement.scrollTop<=(this.i_height+tmp1)){
        this.dIndex = 1;
      } else if(e.srcElement.scrollTop>(this.i_height+tmp1)&&e.srcElement.scrollTop<=(this.i_height+2*tmp1)){
        this.dIndex = 2;
      }  else if(e.srcElement.scrollTop>(this.i_height+2*tmp1)&&e.srcElement.scrollTop<=(this.i_height+3*tmp1)){
        this.dIndex = 3;
      }else {
        this.dIndex = 0;
      }
    },
    getHeight(index,state){
      this.i_height = index+window.innerHeight;
      this.state = state;
      console.log(this.state);
    }
  },
  mounted() {
    this.w_width = window.innerWidth;
    console.log(this.w_width);
    this.$refs.scollElement.addEventListener('scroll',this.getScroll);
  },
  activated() {},
});
</script>
<style scoped>
.aaa {
  overflow: scroll;
}
.rou {
  min-height: calc(100% - 323px);
}
.beianlink{
    color: #797788;
    text-decoration: none;
}
.beianlink:hover{
    color: #536DFE;
}
</style>
